export default "__VITE_ASSET__e11368c5__"